const Hero = () => {
  return (
    <div className="relative flex flex-wrap min-h-screen gap-2 md:-mt-10 bg-secondary">
      <div className="flex-1 basis-[20rem] !text-slate-100 px-[3%] md:px-[6%] mt-20">
        <h1 className="text-4xl font-bold capitalize lg:text-5xl">
          Your dream <br /> apartment awaits
        </h1>
        <div className="pl-3 mt-5 border-l-4 border-primary">
          <p>
            Located in Shanzu Mombasa, Siloam apartments provide affordable and fully furnished 1, 2 & 3 bedroomed units for rent.
          </p>
        </div>
        <div className="mt-6 overflow-hidden rounded-lg sm:cursor-pointer flex-align-center w-fit">
          <div className="px-3 py-1 bg-primary">
            <span className="text-white">Siloam</span>
          </div>
          <div className="px-3 py-1 bg-[#FCCA35]">
            <span>Apartments</span>
          </div>
        </div>
      </div>
      <div className="flex-1 basis-[20rem] h-full">
        <img
          src="/images/property (36).jpg"
          alt=""
          className="w-full h-fit  sm:h-[100vh] object-cover"
        />
      </div>
    </div>
  );
};

export default Hero;
